const colors = {
  primaryBlue: "rgba(43, 207, 231, 1)",
  lightBlue: "rgba(224, 246, 250, 1)",
  primaryPurple: "rgba(85, 48, 193, 1)",
  lightPurple: "rgba(243, 231, 255, 1)",
  secondaryOrange: "rgba(246, 169, 3, 1)",
  inputFieldGrey: "rgba(247, 246, 248, 1)",
  delete: "rgba(246, 36, 36, 0.17)",
  dropdownGrey: "rgba(233, 236, 241, 1)",
  black: "rgb(0,0,0)",
  white: "rgba(256,256,256,256)",
  primaryColor: "#F1F2F4",
  lightLavender: "#EBE9F5",
};

export default colors;